
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/search",
      function () {
        return require("private-next-pages/coaches/search/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/search"])
      });
    }
  